export const isOwnerRole = (role: 'Owner' | 'Author') => role === 'Owner';
